var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58625_18434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 8.368 15.7013 8.66667 15.3333 8.66667H0.666667C0.298667 8.66667 0 8.368 0 8C0 7.632 0.298667 7.33333 0.666667 7.33333H15.3333C15.7013 7.33333 16 7.632 16 8ZM4.66667 14.6667H3.33333C2.23067 14.6667 1.33333 13.7693 1.33333 12.6667V11.3333C1.33333 10.9653 1.03467 10.6667 0.666667 10.6667C0.298667 10.6667 0 10.9653 0 11.3333V12.6667C0 14.5047 1.49533 16 3.33333 16H4.66667C5.03467 16 5.33333 15.7013 5.33333 15.3333C5.33333 14.9653 5.03467 14.6667 4.66667 14.6667ZM15.3333 10.6667C14.9653 10.6667 14.6667 10.9653 14.6667 11.3333V12.6667C14.6667 13.7693 13.7693 14.6667 12.6667 14.6667H11.3333C10.9653 14.6667 10.6667 14.9653 10.6667 15.3333C10.6667 15.7013 10.9653 16 11.3333 16H12.6667C14.5047 16 16 14.5047 16 12.6667V11.3333C16 10.9653 15.7013 10.6667 15.3333 10.6667ZM12.6667 0H11.3333C10.9653 0 10.6667 0.298667 10.6667 0.666667C10.6667 1.03467 10.9653 1.33333 11.3333 1.33333H12.6667C13.7693 1.33333 14.6667 2.23067 14.6667 3.33333V4.66667C14.6667 5.03467 14.9653 5.33333 15.3333 5.33333C15.7013 5.33333 16 5.03467 16 4.66667V3.33333C16 1.49533 14.5047 0 12.6667 0ZM0.666667 5.33333C1.03467 5.33333 1.33333 5.03467 1.33333 4.66667V3.33333C1.33333 2.23067 2.23067 1.33333 3.33333 1.33333H4.66667C5.03467 1.33333 5.33333 1.03467 5.33333 0.666667C5.33333 0.298667 5.03467 0 4.66667 0H3.33333C1.49533 0 0 1.49533 0 3.33333V4.66667C0 5.03467 0.298667 5.33333 0.666667 5.33333Z",
    fill: "#2970FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58625_18434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.f6d0ed03fe42fcf390876fca613f2a58.svg";
export { ForwardRef as ReactComponent };